import { useTranslation } from "react-i18next";

import { Button, Ligne, Lignes, Modal, ModalBody, ModalFooter } from "@/shared/ui";
import { useChangelog } from "./useChangelog";

/**
 * Modal "What's new" : montre les highlights de la version courante UNE FOIS
 * apres une mise a jour (Tauri only). Self-guarded — ne rend rien hors Tauri
 * et tant que la version courante a deja ete vue.
 *
 * Mount dans App.tsx au niveau du ChromeLayout.
 *
 * Dessin (coque, 01-11-2026) : un `Modal` de la librairie, les nouveautés en
 * `Lignes` (plus de filet gauche teinté) ; le fond ne ferme pas (on a vu la
 * nouveauté, ou on le dit : la croix, le bouton, Échap).
 */
export function ChangelogModal() {
  const { t, i18n } = useTranslation();
  const { entry, version, markRead } = useChangelog();

  if (!entry) return null;

  // Choix de la langue d'affichage : prend la langue courante i18n, fallback FR.
  const lang = (i18n.language?.slice(0, 2) ?? "fr") as "fr" | "en" | "es";
  const bullets = entry.highlights[lang] ?? entry.highlights.fr;

  return (
    <Modal
      isOpen
      onClose={markRead}
      size="sm"
      dismissOnBackdropClick={false}
      title={t("shell.changelog.title", { version })}
      subtitle={t("shell.changelog.subtitle")}
      closeLabel={t("shell.changelog.close")}
    >
      <ModalBody>
        <Lignes>
          {bullets.map((b, i) => (
            <Ligne key={i} etiquette={<span className="block whitespace-normal leading-snug">{b}</span>} />
          ))}
        </Lignes>
      </ModalBody>
      <ModalFooter>
        <Button variant="accent" size="lg" onClick={markRead} className="w-full">
          {t("shell.changelog.close")}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
